import { BaseElement } from "../../base/BaseElement";
import { AuthoringCanvas } from "../AuthoringCanvas";
import * as geom from "js/core/utilities/geom";

export class CustomFooter extends BaseElement {
    containsPoint(pt) {
        return true;
    }

    _build() {
        this.authoringCanvas = this.addElement("authoringCanvas", () => AuthoringCanvas);
    }

    _calcProps(props, options) {
        let { size } = props;

        let authoringCanvasProps = this.authoringCanvas.calcProps(new geom.Size(1280, 70));
        authoringCanvasProps.bounds = new geom.Rect(0, size.height - 70, authoringCanvasProps.size);

        return { size };
    }
}

